import type { Translate } from "./composeMessage";
import type { StepId } from "./ids";

const STEP_KEY: Record<StepId, string> = { 1: "topic", 2: "details", 3: "contact" };

/** Nome del passo nella lingua della richiesta («Argomento», «Dettagli», «Recapiti»). */
export function stepLabel(t: Translate, step: StepId): string {
  return t(`contact.guide.steps.${STEP_KEY[step]}`);
}
